import React from "react";
import { Row, Col, Card } from "react-bootstrap";

const ProviderSelector = ({
    providers,
    channelKey,
    setChannelKey,
    providerKey,
    setProviderKey,
    onNext
}) => {

    const buttonStyle = (active) => ({
        cursor: "pointer",
        borderRadius: 12,
        border: active ? "2px solid #0d6efd" : "1px solid #dee2e6",
        background: active ? "#eef5ff" : "#fff",
        transition: "all .2s ease",
        marginBottom: 12,
        padding: 14,
        boxShadow: active
            ? "0 4px 10px rgba(13,110,253,.15)"
            : "0 2px 5px rgba(0,0,0,.05)"
    });

    return (

        <Row>

            {/* CANAIS */}

            <Col md={4}>

                <h5 className="mb-3">

                    Escolha o canal

                </h5>

                {

                    Object.entries(providers).map(([key, channel]) => {

                        const Icon = channel.icon;

                        return (

                            <Card
                                key={key}
                                style={buttonStyle(channelKey === key)}
                                onClick={() => {
                                    setChannelKey(key);
                                    setProviderKey(null);
                                }}
                            >

                                <Card.Body className="p-2">

                                    <div className="d-flex align-items-center">

                                        <Icon
                                            size={22}
                                            color={channel.color}
                                        />

                                        <div className="ms-3">

                                            <strong>

                                                {channel.label}

                                            </strong>

                                        </div>

                                    </div>

                                </Card.Body>

                            </Card>

                        );

                    })

                }

            </Col>

            {/* PROVIDERS */}

            <Col md={8}>

                <h5 className="mb-3">

                    Escolha o provedor

                </h5>

                {

                    Object.entries(
                        providers[channelKey].providers
                    ).map(([key, provider]) => (

                        <Card
                            key={key}
                            style={buttonStyle(providerKey === key)}
                            onClick={() => {

                                setProviderKey(key);

                                onNext();

                            }}
                        >

                            <Card.Body>

                                <div className="d-flex justify-content-between align-items-center">

                                    <div>

                                        <strong>

                                            {provider.label}

                                        </strong>

                                        {

                                            provider.description && (

                                                <div
                                                    className="text-muted mt-1"
                                                    style={{
                                                        fontSize: 13
                                                    }}
                                                >

                                                    {provider.description}

                                                </div>

                                            )

                                        }

                                    </div>

                                </div>

                            </Card.Body>

                        </Card>

                    ))

                }

            </Col>

        </Row>

    );

};

export default ProviderSelector;